import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "item-span" }




export default /*@__PURE__*/_defineComponent({
  __name: 'amountCard',
  props: {
    amount: {
        type: Number,
    },
    isActiveAmount: {
        type: Boolean,
        default: () => false
    },
    isTopupVisible: {
        type: Boolean,
        default: () => false
    },
    giftRatio: {
        type: Number,
    }
},
  emits: ['handleCardClick'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const handleCardClick = () => {
    emits('handleCardClick')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["amount_card", __props.isActiveAmount ? 'active_card' : '']),
    onClick: handleCardClick
  }, [
    _createTextVNode(" R$ " + _toDisplayString(props.amount) + " ", 1),
    (__props.isTopupVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["topPercentage", __props.isActiveAmount ? 'activeLabel' : 'inactiveLabel'])
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString(props.giftRatio) + "%", 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})